<template>
  <b-container>
    <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
    <b-alert
      :show="showDismissibleAlert"
      dismissible
      @dismissed="showDismissibleAlert=false"
      :variant="variant"
    >{{alertText}}</b-alert>
    <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <b-row>
        <b-col md="6" sm="12" class="mt-2 pb-4">
          <p class="reg-heading-tab">Group Details</p>
          <p></p>
          <div class="reg-tab-container">
            <b-form-group id="grpDist" label="Loan District*" label-size="sm" label-for="ipDist">
              <b-form-select
                id="ipDist"
                :options="districts"
                value-field="DistID"
                text-field="DistName"
                disabled
                required
                size="sm"
                v-model="form.LoanDistrict"
              ></b-form-select>
            </b-form-group>
            <b-form-group
              id="GrpName"
              horizontal
              label="Group Name*"
              label-size="sm"
              label-for="exampleInput1"
            >
              <b-form-input
                id="ipGrpname"
                type="text"
                required
                size="sm"
                placeholder="Group Name"
                v-model="form.GroupName"
                :formatter="format"
                lazy-formatter
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="grpRegNum"
              label-size="sm"
              label="Registration No.*"
              label-for="ipRegNum"
            >
              <b-form-input
                id="ipRegnum"
                type="text"
                :formatter="format"
                lazy-formatter
                v-model="form.CompanyRegNo"
                required
                size="sm"
                placeholder="Registration No."
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="grpTyp"
              horizontal
              label-size="sm"
              label="Company Type*"
              label-for="ipType"
            >
              <b-form-select
                id="ipType"
                :options="CompanyTypes"
                value-field="EmployerCompanyTypeID"
                text-field="EmployerCompanyType"
                required
                size="sm"
                v-model="form.CompanyType"
              ></b-form-select>
            </b-form-group>
            <b-form-group
              id="grpAdrs"
              label="Registered Address*"
              label-size="sm"
              label-for="ipadrs"
            >
              <b-form-input
                id="ipadrs"
                type="text"
                :formatter="format"
                lazy-formatter
                size="sm"
                v-model="form.GroupRegisteredAddress"
                placeholder="Address"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              id="exampleInputGroup2"
              label="Is Under Disability?"
              label-size="sm"
              label-for="exampleInput2"
            >
              <b-form-radio-group
                id="radiosD"
                v-model="form.IsUnderDisability"
                name="radioSubComponentD"
              >
                <b-form-radio value="true">Yes</b-form-radio>
                <b-form-radio value="false">No</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="TAN"
              label-size="sm"
              label-for="exampleInput2"
            >
              <b-form-input
                type="text"
                size="sm"
                :formatter="format"
                lazy-formatter
                v-model="form.GroupTAN"
                placeholder="TAN 10 digit"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="PAN*"
              label-size="sm"
              label-for="exampleInput2"
            >
              <b-form-input
                type="text"
                size="sm"
                :formatter="format"
                lazy-formatter
                v-model="form.GroupPAN"
                :state="validatePan"
                placeholder="PAN 10 digit"
              ></b-form-input>
            </b-form-group>
          </div>
        </b-col>
        <b-col md="6" sm="12" class="mt-2">
          <p>
            <span class="reg-heading-tab">Other Details</span>
          </p>

          <div class="reg-tab-container">
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Business Name*"
              label-size="sm"
              label-for="exampleInput2"
            >
              <b-form-input
                type="text"
                size="sm"
                :formatter="format"
                lazy-formatter
                v-model="form.BusinessName"
                placeholder="Business Name"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup3"
              horizontal
              label="Business Address*"
              label-size="sm"
              label-for="exampleInput2"
            >
              <b-form-input
                type="text"
                size="sm"
                :formatter="format"
                lazy-formatter
                v-model="form.BusinessAddress"
                placeholder="Business Address"
              ></b-form-input>
            </b-form-group>
            <!-- <b-form-group
                      id="exampleInputGroup1"
                      horizontal
                      label="State"
                      label-size="sm"
                      label-for="exampleInput1"
                    >
                      <b-form-select
                        id="exampleInput1"
                        :options="states"
                        value-field="StateID"
                        text-field="StateName"
                        required
                        size="sm"
                        @change.native="filterDistricts"
                        v-model="form.CorrespondenceAddress.StateID"
                      ></b-form-select>
            </b-form-group>-->
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="District*"
              label-size="sm"
              label-for="exampleInput2"
            >
              <b-form-select
                id="exampleInput2"
                :options="districts"
                value-field="DistID"
                text-field="DistName"
                required
                size="sm"
                @change.native="filterTalukas"
                v-model="form.District"
              ></b-form-select>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup3"
              horizontal
              label="Taluka*"
              label-size="sm"
              label-for="exampleInput3"
            >
              <b-form-select
                id="exampleInput3"
                :options="talukas"
                value-field="TalukaID"
                text-field="TalukaName"
                required
                size="sm"
                v-model="form.Taluka"
              ></b-form-select>
            </b-form-group>

            <b-form-group
              id="business-Sector"
              horizontal
              label="Business Sector*"
              label-size="sm"
              label-for="business-Sector-input"
            >
              <b-form-select
                id="business-Sector-input"
                :options="busineSectors"
                required
                size="sm"
              ></b-form-select>
            </b-form-group>

            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Business Description*"
              label-size="sm"
              label-for="exampleInput2"
            >
              <b-form-textarea
                type="textarea"
                size="sm"
                :formatter="format"
                lazy-formatter
                v-model="form.FinalProduct"
                placeholder="Final Product"
                rows="3"
      max-rows="6"
              ></b-form-textarea>
            </b-form-group>
            <b-form-group
              id="grpAmt"
              horizontal
              label="Required Loan Amount*"
              label-size="sm"
              label-for="ipAmt"
            >
              <b-form-input
                id="ipAmt"
                type="number"
                v-model="form.LoanAmount"
                required
                size="sm"
                min="2000000"
                max="5000000"
                placeholder="Loan Amount"
              ></b-form-input>
            </b-form-group>
            <!-- <b-form-group
              id="grpBank"
              horizontal
              label="Bank Name*"
              label-size="sm"
              label-for="inpbankName"
            > -->
              <!-- <b-form-select
                id="inpbankName"
                :options="Banks"
                value-field="BankName"
                text-field="BankName"
                required
                size="sm"
                @change.native="filterBranches"
                v-model="form.BankName"
              ></b-form-select> 
            </b-form-group>-->
            <!-- <b-form-group id="grpBranch" label="Branch Name*" label-size="sm" label-for="inpBranch">
              <b-form-input
                id="inpBranch"
                type="text"
                v-model="form.Branch"
                required
                size="sm"
                placeholder="Branch Name"
              ></b-form-input>
            </b-form-group> -->
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-2" v-if="!form.LockProfile">
        <b-col style="text-align:center">
          <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
          <b-alert
            :show="showDismissibleAlert"
            dismissible
            @dismissed="showDismissibleAlert=false"
            :variant="variant"
          >{{alertText}}</b-alert>
        </b-col>
        <b-col style="text-align:right" class="button-wrap">
          <b-button type="submit" variant="primary">Submit</b-button>
          <b-button type="reset" variant="danger">Reset</b-button>
          <b-button variant="secondary" @click="onClickButton" v-if="saved">Next</b-button>
        </b-col>
      </b-row>
    </b-form>
    <br />
  </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import DatePicker from "vue2-datepicker";
import Formatter from "@/Formatter.js";
export default {
  name: "PersonalDetails",
  components: { Spinner, DatePicker },
  data() {
    return {
      DOB: null,
      form: {
        GroupID: "00000000-0000-0000-0000-000000000000",
        UserID: "00000000-0000-0000-0000-000000000000",
        GroupName: "",
        CompanyRegNo: "",
        CompanyType: "",
        IsUnderDisability: false,
        GroupTAN: "",
        GroupPAN: "",
        GroupRegisteredAddress: "",
        BusinessName: "",
        BusinessAddress: "",
        District: "",
        Taluka: "",
        FinalProduct: "",
        LoanAmount: 0,
        LoanDistrict: "",
        BankName: "",
        Branch: ""
      },
      Banks: [],
      CompanyTypes: [],
      CompanyTypeOption: [
        {
          ID: "Government Approved Saving Group",
          RelationshipName: "Government Approved Saving Group"
        },
        {
          ID: "Partnerships",
          RelationshipName:
            "Partnerships (Approved by Registrar of Firms, Maharashtra State, Mumbai)"
        },
        {
          ID: "Co-Operative Firms",
          RelationshipName:
            "Co-Operative Firms (Approved by District Sub-Registrar)"
        },
        {
          ID: "Company/LLP/Society",
          RelationshipName:
            "Company/LLP/Society (As mentioned on webportal of Company Act 2013)"
        },
        {
          ID: "FPO",
          RelationshipName: "Farm Produce Organization (FPO)"
        },
        {
          ID: "SHG",
          RelationshipName: "Self Help Group (SHG)"
        }
      ],
      districts: [],
      talukas: [],
      busineSectors: [
          { value: '1', text: 'Agriculture, allied and traditional activities' },
          { value: '2', text: 'Small scale industries and Medium scale industries' },
          { value: '3', text: 'Service Sector'},
        ],
      show: true,
      alertText: "",
      showDismissibleAlert: false,
      variant: "success",
      isLoading: false,
      dismissSecs: 5,
      dismissCountDown: 0,
      saved: false
    };
  },
  computed: {
    validatePan() {
      if (this.form.GroupPAN == null) {
        return false;
      }

      if (this.form.GroupPAN.length == 0) {
        return false;
      } else if (this.form.GroupPAN != null) {
        var panformat = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
        if (this.form.GroupPAN.match(panformat)) {
          return true;
        } else {
          return false;
        }
        //PAN 5th letter should match Surname's first l
        //Kuldip Removed this condition as Married woman face problem
        // if (
        //   this.form.PanCardNo.match(panformat) &&
        //   this.form.PanCardNo.charAt(4).toLowerCase() ==
        //     this.form.LastName.charAt(0).toLowerCase()
        // ) {
        //   return true;
        // } else {
        //   return false;
        // }
        //return true;
      } else {
        return false;
      }
    },
    validateTan() {
      if (this.form.GroupTAN == null) {
        return true;
      }

      if (this.form.GroupTAN.length == 0) {
        return false;
      } else if (this.form.GroupTAN != null) {
        var panformat = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
        if (this.form.GroupTAN.match(panformat)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: {
    onClickButton() {
      this.saved = false;
      this.showDismissibleAlert = false;
      this.$emit("clicked");
    },
    format(value, event) {
      if (value != null) {
        return value.trim();
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    convertDateFormat(indate) {
      return indate.split("T")[0];
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.isLoading = true;
      this.showDismissibleAlert = false;
      this.saved = false;

      if (!this.validatePan) {
        this.alertText = "Please verify the PAN";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }

      // if (!this.validateTan) {
      //   this.alertText = "Please verify the TAN";
      //   this.variant = "warning";
      //   this.showDismissibleAlert = true;
      //   this.isLoading = false;
      //   return;
      // }

      var userinfo = this.$store.getters.loggedUser;
      this.form.UserID = userinfo.UserId;

      let promise = apis.saveGroup(this.form);
      //this.$store.dispatch("setUserData", this.form);
      promise
        .then(response => {
          if (response.status == 200) {
            this.alertText = "Data Saved Successfully";
            this.form = response.body;
            this.$store.dispatch("setGroupID", this.form.GroupID);
            this.$store.dispatch("setLoanDistrict", this.form.LoanDistrict);
            this.variant = "success";
            this.showDismissibleAlert = true;
            this.saved = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message || "Error while saving data";
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset() {
      this.form = {
        GroupID: "",
        UserID: "",
        GroupName: "",
        CompanyRegNo: "",
        CompanyType: "",
        IsUnderDisability: false,
        GroupTAN: "",
        GroupPAN: "",
        GroupRegisteredAddress: "",
        BusinessName: "",
        BusinessAddress: "",
        District: "",
        Taluka: "",
        FinalProduct: "",
        LoanAmount: 0,
        LoanDistrict: ""
      };
    },
    filterDistricts(evt) {
      let id = evt.target.value;
      this.getDistricts(id);
    },

    getDistricts(stateid) {
      let promise = apis.getDistricts(stateid);

      promise
        .then(response => {
          if (response.status == 200) {
            this.districts = response.body;
            this.isLoading = false;
            //this.$router.push("/");
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },

    filterTalukas(evt) {
      let id = evt.target.value;
      this.form.LoanDistrict = id;
      let district = _.filter(this.districts, { DistID: id });
      if (district) {
        this.$store.dispatch("setLocation", district[0].DistName);
      }
      this.getTalukas(id);
    },

    getTalukas(districtId) {
      if (this.districts.length > 0) {
        let district = _.filter(this.districts, { DistID: districtId });
        if (district) {
          this.$store.dispatch("setLocation", district[0].DistName);
        }
      }
      let promise = apis.getTaluka(districtId);

      promise
        .then(response => {
          //console.log('Reponse' ,response);
          if (response.status == 200) {
            this.talukas = response.body;
            this.isLoading = false;
            //this.$router.push("/");
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },

    getCompanyType() {
      let promise = apis.ReadCompanyTypes();

      promise
        .then(response => {
          //console.log('Reponse' ,response);
          if (response.status == 200) {
            this.CompanyTypes = response.body;
            this.isLoading = false;
            //this.$router.push("/");
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    ReadBanks() {
      let promise = apis.ReadBankMaster();

      promise
        .then(response => {
          //console.log('Physical Response' ,response);
          if (response.status == 200) {
            this.Banks = response.body;
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    }
  },
  mounted() {
    this.getDistricts("BB62F7B0-748D-4E64-AD4F-8EF691431FA1");
    this.getCompanyType();
    this.ReadBanks();
    var userinfo = this.$store.getters.loggedUser;
    if (this.$store.getters.isLoggedIn) {
      let promiseU = apis.ReadGroup(userinfo.UserId);

      promiseU
        .then(response => {
          if (response.status == 200) {
            if (response.body.length > 0) {
              this.form = response.body[0];
              this.$store.dispatch("setGroupID", this.form.GroupID);
              this.$store.dispatch("setLoanDistrict", this.form.LoanDistrict);
              this.getTalukas(this.form.District);
            }
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    }
  }
};
</script>

<style>
.form-group {
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/RegistrationLoan/GroupDetails.vue